import React from 'react';
import { TrendingUp, Globe, Compass, Users, Mail, ArrowUpRight } from 'lucide-react';

const OverviewTab = ({
  stats,
  extendedStats,
  visitors,
  messages,
  setActiveTab,
  getCountryFlag,
  getReferrerIcon,
  getDeviceIcon,
  formatDate
}) => {
  const maxViews = Math.max(...(stats.last7DaysViews?.map((d) => d.count) || [1]), 1);

  return (
    <div className="tab-pane overview-pane">
      {/* Top Row: 7-Day Traffic Graph & Top Referrers */}
      <div className="overview-grid-2col">
        {/* 7-Day Visual Traffic Graph */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <TrendingUp className="panel-icon cyan" />
              <h3>7-DAY TRAFFIC TREND</h3>
            </div>
            <span className="panel-sub-tag">LIVE TELEMETRY</span>
          </div>

          <div className="panel-body">
            <div className="traffic-bar-chart">
              {stats.last7DaysViews?.map((day, idx) => {
                const heightPercent = Math.round((day.count / maxViews) * 100);

                return (
                  <div key={idx} className="chart-bar-column">
                    <span className="bar-count-val">{day.count}</span>
                    <div className="bar-track">
                      <div
                        className="bar-fill"
                        style={{ height: `${Math.max(heightPercent, 8)}%` }}
                      >
                        <div className="bar-fill-glow"></div>
                      </div>
                    </div>
                    <span className="bar-day-lbl">{day._id}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Top Referrers */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <Compass className="panel-icon purple" />
              <h3>TOP TRAFFIC SOURCES</h3>
            </div>
            <span className="panel-sub-tag">REFERRER DOMAINS</span>
          </div>

          <div className="panel-body">
            <div className="rank-list">
              {stats.topReferrers?.slice(0, 5).map((ref, idx) => {
                const percentage = stats.totalViews > 0 
                  ? Math.round((ref.count / stats.totalViews) * 100) 
                  : 0;

                return (
                  <div key={idx} className="rank-item">
                    <div className="rank-left">
                      <span className="rank-badge">#{idx + 1}</span>
                      <span className="rank-icon-symbol">{getReferrerIcon(ref._id)}</span>
                      <span className="rank-name">{ref._id}</span>
                    </div>
                    <div className="rank-right">
                      <div className="rank-progress-bar">
                        <div className="rank-progress-fill" style={{ width: `${percentage}%` }}></div>
                      </div>
                      <span className="rank-count">{ref.count} ({percentage}%)</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Middle Row: Top Countries & Recent Visitors Snippet */}
      <div className="overview-grid-2col" style={{ marginTop: '24px' }}>
        {/* Top Countries */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <Globe className="panel-icon green" />
              <h3>GEOGRAPHIC DEMOGRAPHICS</h3>
            </div>
            <span className="panel-sub-tag">TOP COUNTRIES</span>
          </div>

          <div className="panel-body">
            <div className="rank-list">
              {stats.topCountries?.slice(0, 5).map((country, idx) => {
                const percentage = stats.totalViews > 0 
                  ? Math.round((country.count / stats.totalViews) * 100) 
                  : 0;

                return (
                  <div key={idx} className="rank-item">
                    <div className="rank-left">
                      <span className="rank-badge">#{idx + 1}</span>
                      <span className="rank-flag">{getCountryFlag(country._id)}</span>
                      <span className="rank-name">{country._id}</span>
                    </div>
                    <div className="rank-right">
                      <div className="rank-progress-bar">
                        <div className="rank-progress-fill green" style={{ width: `${percentage}%` }}></div>
                      </div>
                      <span className="rank-count">{country.count} ({percentage}%)</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Recent Messages Quick Peek */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <Mail className="panel-icon pink" />
              <h3>RECENT CONTACT MESSAGES</h3>
            </div>
            <button className="panel-action-link" onClick={() => setActiveTab('messages')}>
              <span>VIEW INBOX</span>
              <ArrowUpRight size={14} />
            </button>
          </div>

          <div className="panel-body">
            {messages.length === 0 ? (
              <div className="empty-state">No contact messages received yet.</div>
            ) : (
              <div className="recent-msg-list">
                {messages.slice(0, 3).map((msg) => (
                  <div key={msg._id} className={`recent-msg-card ${msg.status || 'unread'}`}>
                    <div className="msg-card-top">
                      <span className="msg-sender">{msg.name}</span>
                      <span className="msg-time">{formatDate(msg.createdAt)}</span>
                    </div>
                    <div className="msg-subject">{msg.subject}</div>
                    <div className="msg-snippet">{msg.message?.slice(0, 80)}...</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
